module.exports = __webpack_public_path__ + "img/PixelAliens.e1e1341c.png";